module.exports = __webpack_public_path__ + "img/SoundPicture.f3f6cc52.png";